module.exports = __webpack_public_path__ + "static/media/driver.e9166639.png";